import { App } from "./components/App";
import "./index.scss";

export default App;
